export default "__VITE_ASSET__2yk4NOfU__"